import classNames from "classnames";
import React, { ComponentProps } from "react";
import { Button } from "../button";

import "./cta-button.css";

export const CtaButton = ({
	children,
	hidden,
	ref,
	...props
}: ComponentProps<"button"> & {
	ref?: React.Ref<HTMLButtonElement>;
}) => {
	const styles = classNames("cta-button", props.className, {
		"cta-button--hidden": hidden,
	});

	return (
		<Button {...props} variant="filled" round={false} ref={ref} className={styles}>
			{children}
		</Button>
	);
};
CtaButton.displayName = "CtaButton";
